module.exports = __webpack_public_path__ + "img/Weapon_39.2876dbea.png";